import { FC, useMemo } from 'react';
import { CommercialConditionDetail } from '../CommercialCondition';
import { SmartDecisionData } from './types';
import styles from './index.module.less';
import V2Title from '@/common/components/Feedback/V2Title';
import BrandSynergyAnalysis from './BrandSynergyAnalysis';
import CalculateFunnel from './CalculateFunnel';
import Conclusion from './Conclusion';
import CostPaybackAnalysis from './CostPaybackAnalysis';
import SimilarStores from './SimilarStores';

// 2026-10-20 范围确认：投资总览、构成占比、三阶段计划、ROI 及 8 项 tooltip 配套改造已取消；现有成本/回本展示保留，租金判定文案仅在 Conclusion 配合调整。

interface IntelligentDecisionProps {
  /**
   * 智能决策数据，由父级 MallDecisionReport 统一请求后下发。
   *
   * 【不要在本组件内部再请求 /decision/mallReport/smartDecision】
   * 请求层按 URL 去重并自动 cancel 先发出的那次请求，而子组件 effect 先于父组件执行，
   * 内部重复请求会被父级的请求 cancel，导致拿不到数据。详见父级 loadDetail 上的注释。
   */
  decisionData?: SmartDecisionData;
  /** 商务条件详情，用于读取商务类型。 */
  commercialConditionDetail?: CommercialConditionDetail;
  /** 商场等级，用于生成决策结论文案。 */
  mallLevel?: string;
  /** 是否是分享 */
  shared?: boolean;
}
/**
 * @Description 商场决策报告-智能决策
 */

const IntelligentDecision: FC<IntelligentDecisionProps> = ({
  decisionData,
  commercialConditionDetail,
  mallLevel,
  shared,
}) => {
  const isPreset = useMemo(() => {
    const { summary } = decisionData || {};
    return summary?.dataSource === 'PRESET';
  }, [decisionData]);
  return (
    <section
      className={styles.intelligentDecision}
      data-report-anchor='decision'
    >
      <V2Title
        type='H2'
        bold
      >
        <div className={styles.titCon}>
          <div className={styles.titImg}>
            <img src={`${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/mallDecision/icon_module_AI@2x.png`} width='100%' height='100%' />
          </div>
          <div className='fs-18 bold c-222 ml-6'>
          智能决策
          </div>
          {/* <span className={styles.aiTag}>AI预测</span> */}
        </div>
      </V2Title>
      {/* 决策结论 */}
      <Conclusion
        data={{
          mallLevel,
          summary: decisionData?.summary,
          similarStoreModule: decisionData?.similarStoreModule,
          salesEstimation: decisionData?.salesEstimation,
          brandSynergyModule: decisionData?.brandSynergyModule,
          costAnalysis: decisionData?.costAnalysis,
          commercialConditionDetail,
        }}
      />
      {/* 相似门店 */}
      <SimilarStores
        similarStoreModule={decisionData?.similarStoreModule}
        shared={shared}
      />
      {/* 销售额测算过程 */}
      <CalculateFunnel
        salesEstimation={decisionData?.salesEstimation}
      />
      {/* 品牌协同系数分析 */}
      <BrandSynergyAnalysis
        brandSynergyModule={decisionData?.brandSynergyModule}
        isPreset={isPreset}
      />
      {/* 成本与回本分析 */}
      <CostPaybackAnalysis
        costAnalysis={decisionData?.costAnalysis}
        summary={decisionData?.summary}
        commercialConditionDetail={commercialConditionDetail}
      />
    </section>
  );
};

export default IntelligentDecision;
